import type {
  Listing,
  ListingInventoryItem,
  ListingPrice,
} from "../../../../types/listings.types";

/** A listing is FSV when its `full_service` is set and `active`. */
const isFsvListing = (listing: Listing | null | undefined) =>
  listing?.full_service?.active === true;

/**
 * FSV spaces have a single included food-and-drink inventory item whose
 * `unit_cost` is the F&B minimum; read it as returned.
 */
const getFoodAndDrinkMinimum = (items: ListingInventoryItem[] = []) =>
  items.find(
    (item) => item.type === "included" && item.category === "food_drinks",
  )?.unit_cost ?? 0;

/** The active flat-rate price, which is the FSV space rental. */
const getFlatRatePrice = (prices: ListingPrice[] = []) =>
  prices.find(
    (price) => price.type === "FLAT_RATE" && price.obj_state === "ACTIVATED",
  );

export { getFlatRatePrice, getFoodAndDrinkMinimum, isFsvListing };
